export default "assets/images/logo-b9a2176a.png";